import { Pipe, PipeTransform } from '@angular/core';
import { secondsToDhms } from '../helpers';

@Pipe({
    name: 'convertDateToDhms'
})

export class ConvertDateToDhmsPipe implements PipeTransform {
    transform(fromDate: any, toDate: any): string {
        fromDate = fromDate ? new Date(fromDate) : new Date();

        if(toDate.includes('Z')){
            toDate = toDate.replace("Z","");
        }

        toDate = toDate ? new Date(toDate) : new Date();

        let seconds = Math.abs(fromDate.getTime() - toDate.getTime());
        seconds =  Math.floor(seconds / 1000);

        let result = secondsToDhms(seconds);
        return result;
    }
}

